import React from 'react'

import {BookingStatusLink} from '@vio/core/src/api-types/bovio/response/booking_status'
import {LinkType} from '@vio/core/src/booking/types/Link'

export enum ServerCode {
  Stripe = 'STP',
  Eps = 'EPS',
  Ppn = 'PPN'
}

export enum StatusCodes {
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
  TIMEOUT = 'TIMEOUT',
  ERROR = 'ERROR'
}

export interface FinalizationBookingResponse {
  success: boolean
  link?: LinkType | BookingStatusLink
  error?: Error
}

export interface Psd2Strategy<SetupResponse, InitializeBookingParams> {
  setup: <Config>(config?: Config) => Promise<SetupResponse> | null
  beforeBooking?: () => void
  initializeBooking: (
    res: InitializeBookingParams
  ) => Promise<BaseInitializationResponse> | null
  finalizeBooking: () => Promise<FinalizationBookingResponse>
  iframeRef?: React.RefObject<HTMLIFrameElement>
  challenge: <Config>(config?: Config) => Promise<ChallengeResponse> | null
  isEnrolled: (
    resp: InitializeBookingParams,
    isChargeLater?: boolean
  ) => boolean
  serverCode: ServerCode
}

export interface BaseInitializationResponse {
  statusCode: StatusCodes
  message?: string
}

export interface ChallengeResponse {
  status: StatusCodes
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error?: any
}

export interface BoFHResponses<InitializationType> {
  initialization?: InitializationType
  challenge: unknown
  isChargeLater?: boolean
}
